import React, { useEffect, useState } from 'react';
import Delete from '../../../../../Assets/Lens/deleteLens.svg';
import Flag from '../../../../../Assets/Lens/flag.svg';
import { useDispatch, useSelector } from 'react-redux';
import { deleteComment } from '../../../../../lib/utils/apiCalls';
import { showToast } from '../../../../../Components/Toaster/Toaster';
import { setModal, toggleChildCommentDeleted, toggleCommentDeleted } from '../../../../../Features/lensSlice';

function CommentKebab({ kebabOpen, boxRef, comment }) {
    const dispatch = useDispatch();
    const [visible, setVisible] = useState(false);

    const storeData = useSelector((state) => state.lens.storeData.storeData);
    const selectedComment = useSelector((state) => state.lens.modal.selectedComment);

    async function handleDeleteComment(e) {
        e.stopPropagation();

        try {
            const response = await deleteComment(comment.id);

            if(response?.status === 200) {
                showToast('Comment deleted.', 'success');
                if(selectedComment.ParentId) {
                    dispatch(toggleChildCommentDeleted());
                }
                else {
                    dispatch(toggleCommentDeleted());
                }
            }
        }
        catch(err) {
            showToast(`${err}`, 'error');
        }
    }

    function handleReportComment(e) {
        e.stopPropagation();
        dispatch(setModal('report-comment'));
    }

    useEffect(() => {
        if(kebabOpen) {
            setVisible(true);
        } else {
            setVisible(false);
        }
    }, [kebabOpen]);

    return (
        <div ref={boxRef} className={`${visible ? 'opacity-100 visible' : 'opacity-0 invisible'} transition-all duration-150 ease-in-out absolute w-[238px] px-2 py-1 rounded-md bg-[#FFFFFF] top-7 right-1 shadow-[0px_0px_12px_0px_#0000003D]`}>
            {
                (storeData.id === (comment.SellerUserId || comment.UserId)) ? 
                <>
                    <button onClick={handleDeleteComment} className='w-full flex items-center p-2 gap-[6px] rounded hover:bg-[#F5F5F5]'>
                        <img src={Delete} alt="" />

                        <p className='font-medium text-[14px] leading-5 text-[#121212]'>Delete</p>
                    </button>
                </> :
                <>
                    <button onClick={handleReportComment} className='w-full select-none flex items-center p-2 gap-[6px] rounded hover:bg-[#F5F5F5]'>
                        <img src={Flag} alt="" />

                        <p className='font-medium text-[14px] leading-5 text-[#121212]'>Report this Comment</p>
                    </button>
                </>
            }
        </div>
    )
}

export default CommentKebab;
